// mockPosts.js

export const posts = [
    {
      id: '1',
      title: 'The Art of Photography',
      excerpt: 'An exploration into the world of photography...',
      content: '<p>This is the full content of the first post.</p>',
      author: 'Team',
      category: 'Techniques',
    },
    {
      id: '2',
      title: 'Capturing the Perfect Moment',
      excerpt: 'Insights from my recent photo shoot...',
      content: '<p>This is the full content of the second post.</p>',
      author: 'John Doe',
      category: 'Experiences',
    },
    // Add more mock posts as needed
  ];